import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Day2 from '../Day2/Day2';
import Debattale from '../Debattale';
import Vaad from '../Vaad';
import Nrityarupakam from '../Nrityarupakam';
import StreetPlay from '../StreetPlay';
import ChromaQuest from '../ChromaQuest';
import Sci from '../Sci';
import Fusion from '../Fusion';
import CodeClash from '../CodeClash';
import VeritasInterna from '../VeritasInterna';
import NpsyprMUN from '../NpsyprMUN';
import Commerce from '../Commerce';
import GenusVincere from '../GenusVincere';
import Art from '../Art';

const FaqGroupItem = () => {
  const theme = useTheme();
  return (
    
    <Box id='Day2'>
        
      <br></br>
      <br></br>
      <Typography variant='h6' align='center' fontWeight={700} >
        DAY 2
      </Typography>
      <Box
  sx={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    mb: 2,
  }}
>
  <Button
    href="/event-gallarygoonj2026"
    variant="contained"
    sx={{
      display: "inline-flex",
      width: "auto",
      minWidth: "unset",
      flexShrink: 0,

      fontWeight: 900,
      px: 3.4,
      py: 1.25,
      borderRadius: "999px",
      textTransform: "none",
      letterSpacing: 0.2,
      whiteSpace: "nowrap",

      border: "1px solid rgba(255, 255, 255, 0.55)",
      boxShadow:
        "0 10px 24px rgba(33, 150, 243, 0.28), 0 0 0 1px rgba(33, 150, 243, 0.18)",

      background:
        "linear-gradient(120deg, #0d47a1 0%, #1976d2 42%, #64b5f6 72%, #1565c0 100%)",
      backgroundSize: "220% 220%",

      position: "relative",
      overflow: "hidden",

      animation:
        "galleryPulse 1.9s ease-in-out infinite, galleryGradient 5s ease infinite",

      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(105deg, transparent 20%, rgba(255,255,255,0.55) 45%, transparent 70%)",
        transform: "translateX(-100%)",
        animation: "galleryShine 2.2s linear infinite",
      },

      "& span": {
        position: "relative",
        zIndex: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      },

      "&:hover": {
        background:
          "linear-gradient(120deg, #0d47a1 0%, #1976d2 42%, #64b5f6 72%, #1565c0 100%)",
      },

      "@keyframes galleryPulse": {
        "0%, 100%": {
          boxShadow:
            "0 0 0 0 rgba(33, 150, 243, 0.36), 0 10px 24px rgba(33, 150, 243, 0.28)",
        },
        "50%": {
          boxShadow:
            "0 0 0 9px rgba(33, 150, 243, 0.13), 0 14px 30px rgba(33, 150, 243, 0.36)",
        },
      },

      "@keyframes galleryGradient": {
        "0%, 100%": {
          backgroundPosition: "0% 50%",
        },
        "50%": {
          backgroundPosition: "100% 50%",
        },
      },

      "@keyframes galleryShine": {
        "0%": {
          transform: "translateX(-100%)",
        },
        "100%": {
          transform: "translateX(100%)",
        },
      },
    }}
  >
    <span>Event Gallery</span>
  </Button>
</Box>

      <Box marginBottom={2} marginLeft={3} marginRight={3}>
        <br></br>

        <Day2/>
      </Box>

      <Box>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000}  align='left'>Litage Faire</Typography>
            <Typography  align='right'>- Debattle</Typography>

          </Box>
          <AccordionDetails>
Powerful arguments, confident voices, and ideas that sparked meaningful dialogue.
          </AccordionDetails>

          <Debattale/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
          {/* <a href="#Day2" align='right'>Back to DAY 2</a> */}
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000}  align='left'>Aarush</Typography>
            <Typography  align='right'> - Natya Darpan</Typography>

          </Box>
          <AccordionDetails>
Classic Hindi literature came alive through compelling theatrical performances.        
          </AccordionDetails>

          <Vaad/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000} align='left'>Chetana</Typography>
            <Typography align='right'> - Charcha Vedike</Typography>

          </Box>
          <AccordionDetails>
Thought-provoking discussions showcased the power of
diverse perspectives and meaningful dialogue.
          </AccordionDetails>

          <Nrityarupakam/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000} align='left'>Radical</Typography>
            <Typography align='right'> - Math Escape Room</Typography>

          </Box>
          <AccordionDetails>
Logic, teamwork and quick thinking unlocked every mathematical mystery.         
          </AccordionDetails>

          <StreetPlay/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000} align='left'>Radical</Typography>
            <Typography align='right'>- Trail Blazers</Typography>

          </Box>
          <AccordionDetails>
Young engineers transformed mathematical concepts into remarkable bridge designs.
          </AccordionDetails>

          <ChromaQuest/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000} align='left'>Mirrors </Typography>
            <Typography align='right'>- Veritas Vincit</Typography>

          </Box>
          <AccordionDetails>
Future legal minds argued with confidence, logic and conviction.         
          </AccordionDetails>

          <Sci/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000}>SANSAD</Typography>
            {/* <Typography align='right'>- SANSAD</Typography> */}

          </Box>
          <AccordionDetails>
Democracy in action as young parliamentarians debated with confidence and conviction.
          </AccordionDetails>

          <Fusion/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>
        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000}  align='left'>Space bar</Typography>
            <Typography  align='right'> - RoboMaster – CloudAlert Quest</Typography>

          </Box>
          <AccordionDetails>
Technology met innovation as smart solutions predicted tomorrow&apos;s weather.
          </AccordionDetails>

          <CodeClash/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000} align='left'>Exodia</Typography>
            <Typography align='right'> - Finspectra</Typography>

          </Box>
          <AccordionDetails>
Sharp strategies and bold decisions shaped the next generation of financial leaders.
          </AccordionDetails>

          <VeritasInterna/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000} align='left'>Rhythmscape</Typography>
            {/* <Typography align='right'> - Diplomats of Tomorrow</Typography> */}

          </Box>
          <AccordionDetails>
Electrifying performances filled the stage with rhythm, passion and musical brilliance.
          </AccordionDetails>

          <NpsyprMUN/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000} align='left'>Theme Walk – Same City, Different Stories</Typography>
            {/* <Typography align='right'>- Boardroom Battles</Typography> */}

          </Box>
          <AccordionDetails>
Every step revealed a unique story inspired by the spirit of the city.  </AccordionDetails>

          <Commerce/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000} align='left'>FLASHMOB </Typography>
            {/* <Typography align='right'>- F1 Strategy Drive</Typography> */}

          </Box>
          {/* <AccordionDetails>
  F1-themed simulations where teams race through strategy and negotiation.
  </AccordionDetails> */}

          <GenusVincere/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>

        <br></br>

        <Box
          align={'justify'}
          component={Accordion}
          padding={1}
          borderRadius={`${theme.spacing(1)} !important`}
          sx={{
            '&::before': {
              display: 'none',
            },
          }}
        >
          <Box
            component={AccordionSummary}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography fontWeight={1000}>VALEDICTION</Typography>
            {/* <Typography align='right'>- Brush, Beat & Beyond</Typography> */}

          </Box>
          {/* <AccordionDetails>
  Collaborative art, one brushstroke at a time.
  </AccordionDetails> */}

          <Art/>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
          </Box>
        </Box>
        <br></br>

        {/* <Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Rhythmscape</Typography>
    <Typography align='right'>- Battle of the Bands</Typography>

  </Box>
  <AccordionDetails>
  Bands battle it out, blending melody, rhythm and stagecraft.
  </AccordionDetails>

  <Throne/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box> */}
        {/* 
<br></br>
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Dezainovate</Typography>
    <Typography align='right'>- Concepts to Catwalk</Typography>

  </Box>
  <AccordionDetails>
  From imaginative product design to creative problem-solving, culminating in a striking runway showcase of contrasting aesthetics.
  </AccordionDetails>

  <DezainovateDay2/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
<br></br> */}
        {/* 
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Valediction</Typography>
    <Typography align='right'>- Battle of the Bands</Typography>

  </Box>

  <Veledicition/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
<br></br> */}
        {/* 
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Flash Mob</Typography>
    <Typography align='right'>- Battle of the Bands</Typography>

  </Box>
  <AccordionDetails>
  An inter-school rock band competition where bands competed to claim the throne through their performance.
  </AccordionDetails>

  <FlashMob/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br> */}
      </Box>
    </Box>
      
      
  
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Day2Goonj2025 = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            
          ]}
        />
      </Box>
    </Box>
  );
};

export default Day2Goonj2025;
